import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=1bb5de82&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"
import style0 from "./Invoices.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Invoices.vue?vue&type=style&index=1&id=1bb5de82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5de82",
  null
  
)

export default component.exports